import { Collapse } from 'bootstrap';

const accordionCollapseElementList = document.querySelectorAll('#myAccordion .collapse')
const accordionCollapseList = [...accordionCollapseElementList].map(accordionCollapseEl => new Collapse(accordionCollapseEl))